import { DataBean } from "../DataBean";

export class UpdateAccID extends DataBean {



    public async updateAccountantID(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantID_updateAccountantID_com.quickdataerp.bean.accountant.AccountantID", [id]);
    }

}